import { QUESTION_ELEMENT_TEMPLATES } from "./Question";
import { QuestionResultID } from "./QuestionResult";

export type AnswerItemID = number;

export interface AnswerItem {
  created_on: string;
  updated_on: string;
  id: AnswerItemID; // Claire Answer Item ID
  encoded: string;
  raw: string; // Raw answer
  template: QUESTION_ELEMENT_TEMPLATES; // Question's template answered
  ordering: number;
  question_result_id: QuestionResultID;
}
